import { BASE_LINK, formatCurrency, isNullOrWhitespace } from './CommonFunction';

const ImmobiliPrintItem = ({ building, includePhotos = true }) => {
    const excludedProps = [
        "descrizione",
        "id",
        "idAnnuncio",
        "images",
        "key",
        "link",
        "vetrina",
        "visible",
        "tipologia",
        "fasciaVendita",
        "fasciaLocazione",
        "contract",
        "city",
        "indirizzo",
        "prezzo"
    ];

    const propertyName = [
        { original: 'city', name: "città" },
        { original: 'classeEnergetica', name: "classe energetica" },
        { original: 'contract', name: "contratto" },
        { original: 'pianiTotali', name: "piani totali" },
        { original: 'statoImmobile', name: "stato immobile" },
        { original: 'fasciaVendita', name: "fascia di vendita" },
        { original: 'fasciaLocazione', name: "periodo locazione" },
    ];

    // Extract additional properties for display
    let objectKey = Object.keys(building);
    let props = [];
    objectKey.forEach((prop) => {
        if (!excludedProps.includes(prop)) {
            if (building[prop] !== null && building[prop] !== undefined && building[prop].visible == true && !isNullOrWhitespace(building[prop].value)) {
                let val = building[prop].value;
                if (typeof val === 'boolean') {
                    if (val) {
                        val = 'SI';
                    } else {
                        val = 'NO';
                    }
                }
                let mappedProp = {
                    value: val,
                    name: prop
                };
                let mapped = propertyName.find(p => p.original === prop);
                if (mapped) {
                    mappedProp.name = mapped.name;
                }

                props.push(mappedProp);
            }
        }
    });

    // Sort properties alphabetically
    const sortedProps = props.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });

    // Sort images by order property if they exist
    const sortedImages = includePhotos && building.images?.length > 0
        ? [...building.images].sort((a, b) => a.order - b.order)
        : [];

    const showPrezzo = (building.contract.value === 'Vendita' && building.prezzo?.visible === true);
    const hasLocazione = building.fasciaLocazione?.value && building.fasciaLocazione.value.length > 0;

    return (
        <div className="print-item border border-gray-300 p-4 mb-4 break-inside-avoid">
            {/* Property Type Header */}
            <div className="font-bold text-xl text-claim border-t-[3px] border-t-site-lite-orange border-b-[3px] border-b-site-lite-orange mt-2 mb-4 pl-2 break-inside-avoid">
                <span className='capitalize'>{building.tipologia?.value?.at(-1)}</span> in <span className='capitalize'>{building.contract?.value}</span>
                {showPrezzo && <><span> - </span> <span>{building.prezzo?.value}</span></>}
            </div>

            {/* Images Grid */}
            {includePhotos && sortedImages.length > 0 && (
                <div className='mt-4 grid grid-cols-4 gap-4 break-inside-avoid'>
                    {sortedImages.map((image, index) => (
                        <div key={index} className='break-inside-avoid'>
                            <img
                                src={image.url}
                                alt={`Property image ${index + 1}`}
                                className='w-full h-auto object-cover max-h-48'
                            />
                        </div>
                    ))}
                </div>
            )}

            {/* Property Details Grid */}
            <div className='grid grid-cols-1 mb-4 break-inside-avoid'>
                {
                    (building.contract?.visible && building.contract?.value !== null) &&
                    <div className='mt-2 mr-2 text-claim p-2 bg-site-light-grey3 w-fit h-fit break-inside-avoid'>
                        <span className='capitalize'>Contratto</span>: <b>{building.contract?.value}</b>
                    </div>
                }
                {
                    (building.city?.visible && building.city?.value !== null) &&
                    <div className='mt-2 mr-2 text-claim p-2 bg-site-light-grey3 w-fit h-fit break-inside-avoid'>
                        <span className='capitalize'>Città</span>: <b>{building.city?.value}</b>
                    </div>
                }
                {
                    (building.indirizzo?.visible && building.indirizzo?.value !== null && building.indirizzo?.value !== '') &&
                    <div className='mt-2 mr-2 text-claim p-2 bg-site-light-grey3 w-fit h-fit break-inside-avoid'>
                        <span className='capitalize'>Indirizzo</span>: <b>{building.indirizzo?.value}</b>
                    </div>
                }
                {
                    (building.prezzo?.visible && building.prezzo?.value !== null && building.prezzo?.value !== '') &&
                    <div className='mt-2 mr-2 text-claim p-2 bg-site-light-grey3 w-fit h-fit break-inside-avoid'>
                        <span className='capitalize'>Prezzo</span>: <b>{formatCurrency(building.prezzo?.value)}</b>
                    </div>
                }

                {sortedProps.map((prop, index) => {
                    return (
                        <div key={index} className='mt-2 mr-2 text-claim p-2 bg-site-light-grey3 w-fit h-fit break-inside-avoid'>
                            <span className='capitalize'>{prop.name}</span>: <b>{prop.value}</b>
                        </div>
                    )
                })}
            </div>

            {/* Locazione Period */}
            {
                hasLocazione &&
                <div className='mb-4 font-bold text-xl text-claim border-t-[3px] border-t-site-lite-orange border-b-[3px] border-b-site-lite-orange mt-4 pl-2 break-inside-avoid'>
                    Periodo Locazione
                </div>
            }
            {
                hasLocazione &&
                <div className='break-inside-avoid'>
                    {
                        building.fasciaLocazione.value.map((loc, index) => {
                            return (
                                <div key={index} className='mt-2 mr-2 text-claim p-2 bg-site-light-grey3 w-fit h-fit break-inside-avoid'>
                                    <b><span className='capitalize'>{loc}</span></b>
                                </div>
                            )
                        })
                    }
                </div>
            }

            {/* Description */}
            <div className='mb-4 font-bold text-xl text-claim border-t-[3px] border-t-site-lite-orange border-b-[3px] border-b-site-lite-orange mt-4 pl-2 break-inside-avoid'>
                Descrizione
            </div>
            <div className='mb-4 mr-2 text-claim p-2 text-justify break-inside-avoid' dangerouslySetInnerHTML={{ __html: building.descrizione?.value?.replace('\n', '<br />') || '' }}>
            </div>

            {/* Link */}
            <div className='mb-4 mr-2 text-claim p-2 break-inside-avoid'>
                Link annuncio: {BASE_LINK}{building.idAnnuncio}
            </div>
        </div>
    );
};

export default ImmobiliPrintItem;